// extracted by mini-css-extract-plugin
export default {"hoverCard":"HoverCard_hoverCard__+3lxQ"};